import { Component, HostListener, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { YoutubeDataExtractorService } from '../../services/youtube-data-extractor/youtube-data-extractor.service';
import { VideoData } from './models/video-data';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-video-player-modal',
  templateUrl: './video-player-modal.component.html',
  styleUrl: './video-player-modal.component.scss'
})
export class VideoPlayerModalComponent implements OnInit {
  videoData: VideoData;
  loading: boolean;
  isMobile: boolean;
  isExpanded: boolean;
  showMessages: boolean = false;
  modalRef: BsModalRef<VideoPlayerModalComponent>;
  @HostListener('window:resize')
  onResize() {
    if (!document.fullscreenElement) {
      this.checkScreenSize();
    }
  }

  constructor(
    public bsModalRef: BsModalRef,
    private youtubeExtractor: YoutubeDataExtractorService
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.checkScreenSize();
    setTimeout(() => {
      this.setInitialState();
    }, 300);
  }

  setInitialState(): void {
    try {
      const videoId = this.youtubeExtractor.extractYoutubeId(
        this.bsModalRef.content.url
      );
      const embedUrl = this.youtubeExtractor.prepareEmbededUrl(videoId);

      this.videoData = {
        videoId: videoId,
        videoTitle: this.bsModalRef.content.videoTitle,
        videoSubtitle: this.bsModalRef.content.videoSubtitle,
        embedUrl: embedUrl
      };
      this.loading = false;
      setTimeout(() => {
        this.showMessages = true;
      }, 800);
    } catch {
      this.closeModal();
    }
  }

  private checkScreenSize(): void {
    this.isMobile = window.innerWidth <= 768;
  }

  get truncatedSubtitle(): string {
    return this.videoData.videoSubtitle.length > 100
      ? this.videoData.videoSubtitle.substring(0, 100) + '...'
      : this.videoData.videoSubtitle;
  }

  showMoreSubtitle() {
    this.isExpanded = !this.isExpanded;
  }

  closeModal(): void {
    this.bsModalRef.hide();
    this.bsModalRef.content.url = '';
    this.videoData = {
      embedUrl: '' as SafeResourceUrl,
      videoId: '',
      videoSubtitle: '',
      videoTitle: ''
    };
  }
}
